import apiHandler from "../core/apiHandler";

const correlativeApi = apiHandler('document-correlatives');
export default correlativeApi;
